"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roles = void 0;
const Matrix_1 = require("../../../TdWebtoolkitControls/controls/Matrix/Matrix");
const SynView_1 = require("../SynView");
class roles extends SynView_1.SynView {
    constructor() {
        super();
        this.m_hasMenu = false;
    }
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.icon = "fa-building";
    }
    renderContents() {
        let that = this;
        require.ensure(["./roles.less"], (require) => {
            require("./roles.less");
            that.m_$matrix = that.m_$container.find(".rolesMatrix");
            that.createMatrix();
        });
    }
    resizeControls() {
        if (this.m_$matrix)
            this.m_$matrix.synMatrix("resize", this.m_$container.innerWidth(), this.getAvailableHeightForMatrix());
    }
    forceRefresh(modifications) { }
    createMatrix() {
        let that = this;
        that.m_$matrix
            .on("initSuccess", () => {
            that.resizeControls();
        })
            .synMatrix({
            matrixId: "roles",
            rowClickMode: Matrix_1.RowClickMode.Properties,
            colClickMode: Matrix_1.ColumnClickMode.Properties,
            hoverHighlightingMode: Matrix_1.HighlightingMode.OnlyHeaders,
            width: that.m_$matrix.parent().innerWidth(),
            height: that.getAvailableHeightForMatrix()
        });
    }
    getAvailableHeightForMatrix() {
        if (!this.m_$matrix)
            return 0;
        let $parent = this.m_$matrix.parent();
        return $parent.innerHeight() - $parent.children(".headLine").outerHeight(true);
    }
}
exports.roles = roles;
